<script>
import Confirmation from '@/components/widgets/modals/Confirmation'

const defaultForm = () => ({
  device_code: null,
  max_camera: null,
  index_start: null,
  is_support_adas: false,
  is_support_dms: false,
})

export default {
  name: 'FormDeviceCamera',
  components: { Confirmation },
  props: {
    modal: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    initialData: { type: Object, default: null },
    deviceTypeOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: defaultForm(),
      modalConfirm: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.modal
      },
      set(value) {
        this.$emit('update:modal', value)
      },
    },
    loading: {
      get() {
        return this.isLoading
      },
      set(value) {
        this.$emit('update:isLoading', value)
      },
    },
    isEdit() {
      return Boolean(this.initialData?.device_code)
    },
    isValid() {
      return (
        this.form.device_code !== null &&
        this.form.device_code !== '' &&
        Number(this.form.max_camera) > 0 &&
        Number(this.form.index_start) >= 0
      )
    },
  },
  watch: {
    modal(value) {
      if (value) this.initForm()
    },
    initialData: {
      handler() {
        if (this.modal) this.initForm()
      },
      deep: true,
    },
  },
  methods: {
    initForm() {
      if (this.initialData) {
        this.form = {
          device_code: this.initialData.device_code,
          max_camera: this.initialData.max_camera,
          index_start: this.initialData.index_start,
          is_support_adas: Boolean(this.initialData.is_support_adas),
          is_support_dms: Boolean(this.initialData.is_support_dms),
        }
        return
      }

      this.form = defaultForm()
    },
    onlyNumber(event) {
      if (!/[0-9]/.test(event.key)) event.preventDefault()
    },
    closeModal() {
      this.$emit('update:modal', false)
    },
    openConfirm() {
      if (!this.isValid) {
        this.$toast.error('Fill required field')
        return
      }

      this.modalConfirm = true
    },
    afterConfirm() {
      this.$emit('submit', { ...this.form })
      this.modalConfirm = false
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      :title="isEdit ? 'Edit Camera Configuration' : 'Create Camera Configuration'"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <b-form @submit.stop.prevent="openConfirm">
        <b-row>
          <b-col cols="12" class="mb-3">
            <label>Device Code <span class="text-danger">*</span></label>
            <v-select
              v-model="form.device_code"
              :options="deviceTypeOptions"
              label="name"
              :reduce="(option) => option.id"
              :clearable="!isEdit"
              :disabled="isEdit"
              placeholder="Select device code"
            />
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <label>Max Camera <span class="text-danger">*</span></label>
            <b-form-input
              v-model.number="form.max_camera"
              type="number"
              min="1"
              @keypress="onlyNumber"
            />
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <label>Index Start <span class="text-danger">*</span></label>
            <b-form-input
              v-model.number="form.index_start"
              type="number"
              min="0"
              @keypress="onlyNumber"
            />
          </b-col>
          <b-col cols="12" md="6" class="mb-2">
            <b-form-checkbox v-model="form.is_support_adas" switch>
              <span class="ms-1">Support ADAS</span>
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" md="6" class="mb-2">
            <b-form-checkbox v-model="form.is_support_dms" switch>
              <span class="ms-1">Support DMS</span>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end align-items-center mt-3">
          <b-button variant="outline-primary" class="me-3" :disabled="loading" @click="closeModal">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" :disabled="loading">
            <b-spinner v-if="loading" small type="grow"></b-spinner>
            {{ loading ? 'Loading...' : 'Save' }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <confirmation
      v-if="modalConfirm"
      :modal.sync="modalConfirm"
      :message="
        isEdit
          ? 'Are you sure you want to update this camera configuration?'
          : 'Are you sure you want to create this camera configuration?'
      "
      @confirmed="afterConfirm"
      centered
    />
  </div>
</template>
